module.exports = __webpack_public_path__ + "img/upload-5.0a0bd6ca.png";